// src/App.js

import React from "react";

import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

import ExamPortal from "./pages/ExamPortal";

import AdminPortal from "./pages/admin/AdminPortal";
import NotFoundPage from "./pages/NotFound/Notfound";
import ExamPortalComingSoon from "./pages/Homepage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={<ExamPortalComingSoon />}
        />

        <Route
  path="/exam/:paperId"
  element={<ExamPortal />}
/>

        <Route
          path="/admin"
          element={<AdminPortal />}
        />

         <Route
          path="*"
          element={<NotFoundPage />}
        />
      </Routes>
    </BrowserRouter>
  );
}